import * as React from "react";
import {Link} from "react-router-dom";
import {Container, Dropdown, Menu, Image} from "semantic-ui-react";
import {CookieManager} from "../../core/utility/CookieManager";

interface IProps {
    componentName?: string;
}

interface IState {
    selectedMenu: string;
}

export class Layout extends React.Component<IProps,IState> {

    constructor(props: IProps){
        super(props);

        this.state = {
            selectedMenu: 'dashboard'
        }

    }

    public render() {
        return (
            <div className="admin-layout">
                <Container fluid={true} className="p-l-container p-t-container">
                    <Image src='/asset/image/logo-md.png' style={{height: 100}} />
                </Container>

                <Menu inverted={true}>
                    <Container fluid={true} className="p-l-container p-r-container">
                        <Menu.Item as='div' active={this.state.selectedMenu === 'dashboard'}>
                            <Link to={'/admin'} onClick={() => this.changeMenu('dashboard')}>
                                Dashboard
                            </Link>
                        </Menu.Item>
                        <Menu.Item as='div' active={this.state.selectedMenu === 'about'}>
                            <Link to={'/admin/about'} onClick={() => this.changeMenu('about')}>
                                Tentang Desa
                            </Link>
                        </Menu.Item>
                        <Menu.Item as='div' active={this.state.selectedMenu === 'announcement'}>
                            <Link to={'/admin/announcement'} onClick={() => this.changeMenu('announcement')}>
                                Pengumuman
                            </Link>
                        </Menu.Item>
                        <Menu.Item as='div' active={this.state.selectedMenu === 'agenda'}>
                            <Link to={'/admin/agenda'} onClick={() => this.changeMenu('agenda')}>
                                Agenda
                            </Link>
                        </Menu.Item>
                        <Menu.Item as='div' active={this.state.selectedMenu === 'news'}>
                            <Link to={'/admin/news'} onClick={() => this.changeMenu('news')}>
                                Berita
                            </Link>
                        </Menu.Item>
                        <Dropdown item={true} text='Desa'>
                            <Dropdown.Menu>
                                <Dropdown.Item as='div' active={this.state.selectedMenu === 'village-org'}>
                                    <Link to={'/admin/village/organization'} onClick={() => this.changeMenu('village-org')}>
                                        Organisasi Desa
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item as='div' active={this.state.selectedMenu === 'vo-staff'}>
                                    <Link to={'/admin/village/staff'} onClick={() => this.changeMenu('vo-staff')}>
                                        Staff Desa
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item as='div' active={this.state.selectedMenu === 'gallery'}>
                                    <Link to={'/admin/village/gallery'} onClick={() => this.changeMenu('gallery')}>
                                        Galeri Foto
                                    </Link>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown item={true} text='Kelola Dusun'>
                            <Dropdown.Menu>
                                <Dropdown.Item as='div' active={this.state.selectedMenu === 'dusun'}>
                                    <Link to={'/admin/dusun'} onClick={() => this.changeMenu('dusun')}>
                                        Dusun
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item as='div' active={this.state.selectedMenu === 'stt'}>
                                    <Link to={'/admin/dusun/stt'} onClick={() => this.changeMenu('stt')}>
                                        STT
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item as='div' active={this.state.selectedMenu === 'shanti'}>
                                    <Link to={'/admin/dusun/sekaa-shanti'} onClick={() => this.changeMenu('shanti')}>
                                        Sekaa Shanti
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item as='div' active={this.state.selectedMenu === 'gong'}>
                                    <Link to={'/admin/dusun/sekaa-gong'} onClick={() => this.changeMenu('gong')}>
                                        Sekaa Gong
                                    </Link>
                                </Dropdown.Item>
                                <Dropdown.Item as='div' active={this.state.selectedMenu === 'pkk'}>
                                    <Link to={'/admin/dusun/pkk'} onClick={() => this.changeMenu('pkk')}>
                                        PKK
                                    </Link>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                        <Menu.Item as='div' active={this.state.selectedMenu === 'report'}>
                            <Link to={'/admin/citizen-report'} onClick={() => this.changeMenu('report')}>
                                Pengaduan Warga
                            </Link>
                        </Menu.Item>

                        <Menu.Item as='div' active={this.state.selectedMenu === 'aspiration'}>
                            <Link to={'/admin/aspiration-report'} onClick={() => this.changeMenu('aspiration')}>
                                Aspirasi
                            </Link>
                        </Menu.Item>

                        <Menu.Menu position='right'>
                            <Menu.Item
                                onClick={this.logout}
                                name='Logout' />
                        </Menu.Menu>
                    </Container>
                </Menu>

                <Container fluid={true} id="admin-content">
                    {this.props.children}
                </Container>

            </div>
        );
    }

    private logout = () => {
        CookieManager.clearSession();
        window.location.href = '/login';
    };

    private changeMenu = (menu: string) => {
        this.setState({
            selectedMenu: menu
        });
    }
}


// WEBPACK FOOTER //
// ./src/component/layout/Layout.tsx